import React, { memo } from "react";
import { UserProvider } from "./User/context";

interface Props {
  children: React.ReactNode;
}

const AppProvider = memo(({ children }: Props) => {
  return <UserProvider>{children}</UserProvider>;
});

export default AppProvider;
